
export default class {

    constructor() 
    {
        this.close = document.getElementById('close-info');
        this.close.addEventListener('click',this,false);
    }
    
    handleEvent(evt)
    {
        this.constructor.close();
    }

    static close()
    {
        document.getElementById('infoWindow').style.display = 'none';
    }
}
